<div class="bg-th-blue mt-0 container-fluid">
    <div class=" d-flex justify-content-between align-content-center h-35">
        <i class="fa fa-arrow-left text-white my-auto pointer" (click)="goBack()"></i>



    </div>
</div>
<div class="col-12 d-flex flex-column">


    <div class="col-md-5 mt-4 col-11 justify-content-around flex-wrap d-flex dirI mx-auto border border-primary border-2 rounded-3" [formGroup]="saveGeoFence">
        <div class="col-12 ">
            <h4 class="mt-2 mx-auto text-center">تعین محدوده وسیله</h4>
        </div>

        <div class="col-md-5 col-11">
            <div class="mb-2">
                <label class="form-label">نام محدوده</label>
                <select class="form-select" formControlName="iGeoFence">
                    <option value="-1">انتخاب کنید</option>
                    <option *ngFor="let item of GeoFenceData" value="{{item.iGeoFence}}">{{item.strTitle}}</option>
                </select>

            </div>
        </div>
        <div class="col-md-5 col-11">
            <div class="mb-2">
                <label class="form-label">کاربری</label>
                <select class="form-select" formControlName="tiGeoFenceUsgae">
                    <option value="-1" >انتخاب کنید</option>
                    <option *ngFor="let item of geoFenceUsgae" [value]="item.tiGeoFenceUsgae" >{{item.strComment}}</option>
                </select>

            </div>
        </div>
        <div class="col-md-5 col-11 ">
            <label class="mb-2"> از ساعت *</label>

            <div class="input-group clockpicker">
                <input type="text" class="form-control shadow bg-light" value="00:00" id="Stime" readonly formControlName="strSTime">
                <span class="input-group-addon ">
                    <span class="glyphicon glyphicon-time"></span>
                </span>
            </div>

        </div>
        <div class="col-md-5 col-11">
            <label class="mb-2"> تا ساعت *</label>

            <div class="input-group clockpicker">
                <input type="text" class="form-control shadow bg-light" value="23:59" id="Etime" readonly formControlName="strETime">
                <span class="input-group-addon">
                    <span class="glyphicon glyphicon-time"></span>
                </span>
            </div>
        </div>
        <div class="col-md-5 col-11 mt-2">
            <div class="form-check d-flex align-items-center justify-content-between">
                <div>
                    <label class="form-check-label" for="smsSend">
                        ارسال پیامک
                    </label>
                    <input class="form-check-input" type="checkbox" id="smsSend" formControlName="bSendSMS">
                </div>

                <div>
                    <label class="form-check-label" for="warning">
                        ارسال هشدار
                    </label>
                    <input class="form-check-input" type="checkbox" value="" id="warning" formControlName="bSendPush">
                </div>


            </div>
        </div>
        <div class="w-100 d-flex mb-2">
            <button class="btn btn-primary mx-auto" (click)="SaveMobileGeoFence()">ثبت</button>
        </div>
    </div>



    <div class="col-md-5 col-11 mx-auto">
        <h4 class="text-center mt-2">محدوده های ثبت شده متحرک</h4>
        <div class="table-responsive dirI rounded-3 border border-2 my-2">
            <table class="table table-striped     ">
                <thead>
                    <!-- [ngClass]="showLocation  ? 'index-1' : ''" -->
                    <tr class="">

                        <th>نام محدوده </th>
                        <th>نوع </th>
                        <th>حذف </th>


                    </tr>
                </thead>
                <tbody>
                    <tr class="pointer  " *ngFor="let item of pastArea">
                        <td>{{item.strTitle}}</td>
                        <td>{{item.strGeoFenceUsgae_strComment}}</td>

                        <td class="dirl f22" (click)="deleteArea(item.iMobileGeoFences)"><i class="fa fa-trash text-danger "></i></td>

                    </tr>

                </tbody>
            </table>

        </div>
    </div>
    <!-- <div class="col-3 dirI d-flex ">
        <label class="form-label">نام محدوده</label>

        <select class="form-select">
            <option value="-1">انتخاب کنید</option>
            <option></option>
        </select>
        <i class="fa fa-trash text-danger fa-2x"></i>
    </div> -->


</div>